import React from 'react';
import styled from 'styled-components';

import MaterialSymbol from '#/components/basic/icons/MaterialSymbol';
import { formatNumber } from '#/lib/display/formatting';
import { useSelectMarketTickSize } from '#/reduxState/markets/listed/listedMarketsUtils';

import { BuySellConditionalTpSl } from './buyPanelReducer';

const Box = styled.div<{ $isLong: boolean }>`
  width: 100%;
  border-radius: 4px;
  background: ${({ $isLong }) => ($isLong ? 'var(--green1d)' : 'var(--red1)')};
  padding: 4px 8px;
  display: flex;
  justify-content: space-between;
  gap: 4px;
  align-items: center;
  align-self: stretch;
  color: ${({ $isLong }) => ($isLong ? 'var(--green4)' : 'var(--red3)')};
`;

const Text = styled.div`
  font-size: var(--small);
  font-style: normal;
  font-weight: normal;
  line-height: normal;
`;

const ValueText = styled(Text)`
  cursor: pointer;
  display: flex;
  align-items: center;
  text-align: right;
  font-family: var(--digitsFontFamily);
`;

const StyledEditIcon = styled(MaterialSymbol)`
  padding-left: 8px;
`;

type Props = {
  market: string;
  conditionalTpSl: BuySellConditionalTpSl;
  onEditTPSL: () => void;
};

export default function ActiveTPSLInfo({
  market,
  conditionalTpSl,
  onEditTPSL,
}: Props) {
  const tickSize = useSelectMarketTickSize(market);
  const { side, takeProfitPrice, stopLossPrice } = conditionalTpSl;
  return (
    <Box $isLong={side === 'long'}>
      <Text>{side === 'long' ? 'Long' : 'Short'}</Text>
      <ValueText onClick={onEditTPSL}>
        {takeProfitPrice
          ? formatNumber(takeProfitPrice, {
              fixedDecimals: tickSize?.visibleDecimals,
            })
          : '-'}{' '}
        /{' '}
        {stopLossPrice
          ? formatNumber(stopLossPrice, {
              fixedDecimals: tickSize?.visibleDecimals,
            })
          : '-'}
        <StyledEditIcon icon="edit" fontSize="small" />
      </ValueText>
    </Box>
  );
}
